import React from 'react';

import {useBackButtonBooking} from 'presentation/modules/booking/shared/hooks/useBackButtonBooking';
import {translations} from 'presentation/translations-new';
import {BookingFlowLayout} from '../../components/BookingFlowLayout';
import {BookingTypeEnum} from 'presentation/modules/booking/shared/constants/bookingTypeEnum';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';

const {bookTelehealth} = translations['pt-br'].privateFlow.services;
const {confirm, professional, specialty} = translations['pt-br'].privateFlow.bookingFlow.steps;

const LABELS = [specialty, professional, confirm];

export function TelehealthBooking() {
	useBackButtonBooking({flowType: BookingTypeEnum.TELEHEALTH});

	return (
		<BookingFlowLayout
			flowType={FlowEnum.TELEHEALTH}
			headerTitle={bookTelehealth}
			stepLabels={LABELS}
		/>
	);
}
